import { Document, MARKS } from '@contentful/rich-text-types';

type RichTitleProps = {
  doc: Document;
  as?: keyof React.JSX.IntrinsicElements;
  className?: string;
  id?: string;
};

/**
 * Renders a Contentful rich text Document as a single heading element.
 * Bold marks → <strong> styled in primary colour.
 * Italic marks → <em>.
 */
export default function RichTitle({
  doc,
  as: Tag = 'h2',
  className,
  id,
}: RichTitleProps) {
  const blocks = doc?.content ?? [];

  return (
    <Tag className={className} id={id}>
      {blocks.flatMap((block, bi) =>
        (block.content ?? []).map((node, ni) => {
          if (node.nodeType !== 'text') return null;
          const textNode = node as unknown as {
            value: string;
            marks: { type: string }[];
          };
          const marks = textNode.marks ?? [];
          const isBold = marks.some((m) => m.type === MARKS.BOLD);
          const isItalic = marks.some((m) => m.type === MARKS.ITALIC);
          const key = `${bi}-${ni}`;

          if (isBold)
            return (
              <strong key={key} className="font-normal text-primary not-italic">
                {textNode.value}
              </strong>
            );
          if (isItalic) return <em key={key}>{textNode.value}</em>;
          return <span key={key}>{textNode.value}</span>;
        }),
      )}
    </Tag>
  );
}
